var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 32a3 3 0 100 6 3 3 0 000-6zm0-15a3 3 0 100 6 3 3 0 000-6zM23 5a3 3 0 106 0 3 3 0 00-6 0zm-9 27a3 3 0 100 6 3 3 0 000-6zm-3-12a3 3 0 106 0 3 3 0 00-6 0zm3-18a3 3 0 100 6 3 3 0 000-6z"
  })));
}
export default SvgGripDotsVertical;